export enum RouterLinks {
    Project = '/project/',
    Edit = '/edit',
    VerifyBasicInformation = '/verify-basic-information',
    VerifyPrices = '/verify-prices',
    EditPrices = '/edit-prices',
    CreateReport = '/create-report',
    Heatload = '/heatload',
    HeatPump = '/plan-heat-pump',
    Photovoltaic = '/plan-photovoltaic',
    Boiler = '/plan-boiler',
    GEG = 'geg',
    Variants = '/variants',
    ProjectProfitability = '/profitability',
    BasicProfitability = '/basic/',
    RoomByRoomCalculation = '/room-by-room-calculation'
}
